import { AxiosResponse } from 'axios';
import { NotificationEndpoint } from '../common/endpoints';
import { getRequest, postRequest } from './requests';

export type AppNotification = {
  id: number;
  type: string;
  title: string;
  message: string;
  linkUrl?: string | null;
  relatedEntityId?: number | null;
  isRead: boolean;
  createdAt: string;
};
export async function getAllNotifications() {
    const result: AxiosResponse<AppNotification[]> = await getRequest(
        `${NotificationEndpoint}?unreadOnly=false`,
    );
    return result;
}



export async function getUnreadNotificationCount() {
  const result: AxiosResponse<{ count: number }> = await getRequest(
    `${NotificationEndpoint}/unread-count`,
  );
  return result;
}

export async function markNotificationAsRead(id: number) {
  const result: AxiosResponse<void> = await postRequest(
    `${NotificationEndpoint}/${id}/read`,
    {},
  );
  return result;
}
